import { render, staticRenderFns } from "./OpenLockedSlot.vue?vue&type=template&id=8fb3bc80&"
import script from "./OpenLockedSlot.vue?vue&type=script&lang=js&"
export * from "./OpenLockedSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports